/**
 * External dependencies
 */
import { Component } from '@wordpress/element';
import { DatePicker, Popover } from '@wordpress/components';
import moment from 'moment';

/**
 * Internal dependencies
 */
import './style.scss';

class DatePickerPopoverDay extends Component {
	constructor( props ) {
		super( props );
		this.state = {
			showPicker: false,
		};

		this.handleChange = this.handleChange.bind( this );
		const picker = this;

		document.addEventListener( 'click', function( event ) {
			if ( 'wc-bookings-datepicker-toggle-day' === event.target.id ) {
				return;
			}

			if ( event.target.closest( '.wc-bookings-datepicker-popover' ) ) {
				return;
			}

			picker.setState( {
				showPicker: false,
			} );
		} );
	}

	handleChange( datetime ) {
		const date = datetime.substring( 0, 10 );
		document.location.search += '&calendar_day=' + date + '&view=day';
	}

	toggleVisibility() {
		const { showPicker } = this.state;
		this.setState( {
			showPicker: ! showPicker,
		} );
	}

	render() {
		const { showPicker } = this.state;
		const { year, month, day } = this.props;
		return (
			<div>
				<a href="#" onClick={ (e) => { e.preventDefault(); this.toggleVisibility() } } id="wc-bookings-datepicker-toggle-day">
					{ day } <span> &#9662; { showPicker && (
						<Popover className="wc-bookings-datepicker-popover">
							<DatePicker
								onChange={this.handleChange}
								currentDate={moment(Date.parse(day))}
							/>
						</Popover>
					) } </span>
				</a>
			</div>
		);
	}

}
export default DatePickerPopoverDay;
